import { isSaveAsDraftEnabled } from 'app/infrastructure/hosting';
import { debug } from 'app/infrastructure/log';
import { store } from 'app/infrastructure/configure-store';
import { actionCreators as draftActionCreators } from './actions';

/**
 * Saves draft before logout if save as draft is enabled and there are unsaved changes.
 * Should be called from the logout orchestration layer (e.g., shell/hooks.ts).
 */
export async function saveAsDraftBeforeLogout(): Promise<void> {
  if (!isSaveAsDraftEnabled()) {
    return;
  }

  try {
    const state = store.getState();
    const caseState = state.caseArea;
    
    // If there's an active draft being edited with unsaved changes, trigger background save
    if (caseState?.editing && !caseState.editing.pristine) {
      debug('Saving draft before logout...');
      await store.dispatch(draftActionCreators.backgroundSave() as any);
      debug('Draft saved successfully before logout');
    }
  } catch (error) {
    console.error('Failed to save draft before logout:', error);
    // Continue with logout even if save fails
  }
}
